import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Products from '../views/Products.vue'


import Buy from '../views/buy.vue'

import contact from "../views/contact.vue"
import dynamic from "../views/dynamic.vue"
import join from "../views/join.vue"
import member from '../views/member.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/buy',
    name: 'Buy',
    component: Buy
  },

  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    component: dynamic
  },
    {
    path: '/join',
    name: 'join',
    component: join
  },
     {
    path: '/member',
    name: 'member',
    component: member
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 